export const CLAIM_STATUS = {
  NEW: "new",
  PENDING: "pending",
  APPROVED: "approved",
  CLOSED: "closed",
  DENIED: "denied",
} as const;

export const RESOLUTION_TYPE = {
  REFUND: "refund",
  STORE_CREDIT: "store_credit",
  RESHIP: "reship",
  DEFAULT: "default",
} as const;

export const REQUEST_TYPE = {
  RETURN: "return",
  EXCHANGE: "exchange",
} as const;

export const RETURN_STAGE = {
  REQUESTED: "requested",
  LABEL_READY: "labelReady",
  IN_TRANSIT: "inTransit",
  RECEIVED: "received",
  RESOLVED: "resolved",
  DENIED: "denied",
} as const;

export const RETURN_STEP_KEYS = [
  RETURN_STAGE.REQUESTED,
  RETURN_STAGE.LABEL_READY,
  RETURN_STAGE.IN_TRANSIT,
  RETURN_STAGE.RECEIVED,
  RETURN_STAGE.RESOLVED,
];

export const RETURN_DELIVERED_TRACKING_STATUS = "delivered";
export const RETURN_PRE_TRANSIT_TRACKING_STATUS = "pre_transit";

export const TRACKING_BASE_URL = "https://tracking.shipinsure.io/tracking";

export const CARE_EMAIL = "care@shipinsure.io";
